import React, { useEffect, useCallback } from 'react';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import getClientConfig from '../../utils/getClientConfig';
import fetchWrapper from '../../utils/fetch-wrapper';
import { setSessionData, setSessionPromise } from '../../controllers/session'

const {
  guiUrl,
} = getClientConfig();

// Not tracking this in state; b/c this component is a singleton, and trying
// to track this in state really complicates testing
let currentTimer;
function setCurrentTimer(handle) {
  currentTimer = handle;
}

// mock-able error handling function - if session refresh fails, we just reload
// the page which will trigger a redirect back to AI to get a new session.
export function sessionRefreshFailed(/* err */) {
  /* If the access token cannot be refreshed because the refresh
   * token has expired, redirect to login page */
  window.location.reload();
}

function KeepAlive(props) {
  const {
    tokenRefreshWindowInMilliseconds,
    session,
    dispatchSessionData,
    dispatchSessionPromise
  } = props;

  const doRefresh = useCallback(async () => {
    const sessionPromise = fetchWrapper(
      `${guiUrl}/api/session/refresh`,
      { method: 'POST' },
    ).then(result => result.json());

    // setting the promise into the store before yielding
    // otherwise, any parallel requests will proceed and lack access to the promise.
    dispatchSessionPromise(sessionPromise);

    try {
      const newSession = await sessionPromise;
      // update store with new accessToken and clear the promise
      dispatchSessionData({ ...newSession, setAt: new Date() });
      dispatchSessionPromise(null);
    } catch (err) {
      sessionRefreshFailed();
    }
  }, [dispatchSessionData, dispatchSessionPromise]);

  useEffect(() => {
    function clearTimer() {
      if (currentTimer) clearTimeout(currentTimer);
    }

    if (currentTimer) {
      return clearTimer;
    }

    const expires = session?.accessTokenExpireTime && dayjs(session.accessTokenExpireTime, 'YYYY-MM-DDTHH:mm:ss.SSSZ').toDate();

    if (expires) {
      const msToRefresh = expires.getTime() - Date.now() - tokenRefreshWindowInMilliseconds;
      const timer = setTimeout(() => {
        doRefresh();
        setCurrentTimer(null);
      }, Math.max(msToRefresh, 0));

      setCurrentTimer(timer);
    }

    return clearTimer;
  }, [doRefresh, session, tokenRefreshWindowInMilliseconds]);

  return <keep-alive />;
}


function mapStateToProps(state, props) {
  return {
    session: state.session
  }
}

function mapDispatchersToProps(dispatch) {
  return {
    dispatchSessionData: (sessionObj) => {
      dispatch(setSessionData(sessionObj));
    },
    dispatchSessionPromise: (promise) => {
      dispatch(setSessionPromise(promise));
    }
  }
}

export default connect(mapStateToProps, mapDispatchersToProps)(KeepAlive);
